import styled from 'styled-components'
import DynamicComponent from './dynamic-component.js'
import React from 'react'
import theme from './theme.js'

export const paragraphStyles = {
  fontSize: {
    primary: '2.2rem',
    secondary: '1.8rem',
    tertiary: '1.6rem'
  }
}

const {
  fontSize 
} = paragraphStyles

export function getBodyTextSize({level}) {
  const sizeKeys = Object.keys(paragraphStyles.fontSize)
  return fontSize[sizeKeys[level - 1]] || fontSize.primary
}

export const UnstyledBodyText = props => ( 
  <DynamicComponent {...props}>
    {props.children}
  </DynamicComponent>
)

export const BodyText = styled.p`
  font-family: typewriter;
  font-size: ${theme.font.size.p};
  font-weight: 300;
  margin-bottom: 0;
  line-height: 1.5em;

  b {
    font-family: nitti;
  }

  a {
    font-family: underlined;
    cursor: pointer;

    &:hover {
      opacity: .6;
    }
  }
`

export default BodyText

export const BoldText = styled.p`
  font-family: nitti-bold;
  letter-spacing: .025em;
  margin-bottom: 0; 
`

BodyText.font = {
  size: paragraphStyles.fontSize
}

BodyText.defaultProps = {
  level: 1,
  tag: 'p'
}